import React from 'react'

interface StatsCardProps {
  title: string
  value: number | string
  icon: React.ComponentType<{ className?: string }>
  color: 'blue' | 'green' | 'purple' | 'yellow' | 'red'
}

const colorClasses = {
  blue: 'bg-blue-500',
  green: 'bg-green-500',
  purple: 'bg-purple-500',
  yellow: 'bg-yellow-500',
  red: 'bg-red-500',
}

export default function StatsCard({
  title,
  value,
  icon: Icon,
  color,
}: StatsCardProps) {
  return (
    <div className='card'>
      <div className='card-body'>
        <div className='flex items-center'>
          <div className='flex-shrink-0'>
            <div className={`p-3 rounded-md ${colorClasses[color]}`}>
              <Icon className='h-6 w-6 text-white' />
            </div>
          </div>
          <div className='ml-5 w-0 flex-1'>
            <dl>
              <dt className='text-sm font-medium text-gray-500 dark:text-gray-400 truncate'>
                {title}
              </dt>
              <dd className='text-lg font-medium text-gray-900 dark:text-white'>
                {value}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}



